export default __webpack_public_path__ + "static/Technology-Roadmap-21ecbe3d4c9ca5346e7eb1aaa25f9516.webp";